export enum DownloadReportTypeEnum {
    DOWNLOAD_ALL= 'download-all',
    AER_REPORT = 'aer-report',
    CER_REPORT = 'cer-report',
    FINDINGS_REPORT = 'findings-summary'
}
